import { useState, useMemo, useEffect } from 'react';
import { useGET } from '../shared/hooks/useGET';
import { groupBy } from 'lodash';
import { formatMonthYear } from '../../lib/format';
import QueryString from '../../lib/QueryString';

const toUrl = (teamId, query) => `/team/${teamId}/games/stats${query}`;

const pageSize = 15;

export function usePaginatedGamesByMonth(leagueId, seasonId, teamId) {
  const [currentPage, setCurrentPage] = useState(0);
  const [total, setTotal] = useState(0);
  const query = getQuery(leagueId, seasonId, currentPage, pageSize);
  const url = toUrl(teamId, query);
  const data = useGET(url);

  useEffect(() => {
    if (data && data.count !== undefined && total !== data.count) {
      setTotal(data.count);
    }
  }, [data, total]);

  const gamesByMonth = useMemo(() => {
    if (!data || !data.results) return null;
    const byMonth = groupBy(data.results, game =>
      formatMonthYear(game.start_time),
    );
    return Object.keys(byMonth).map(name => ({
      name,
      games: byMonth[name],
    }));
  }, [data]);

  return { gamesByMonth, pageSize, currentPage, setCurrentPage, total };
}

const getQuery = (leagueId, seasonId, currentPage, pageSize, locked = true) => {
  const query = new QueryString();

  query.addValue('ordering', '-start_time');
  query.addValue('limit', pageSize);
  query.addValue('offset', currentPage * pageSize);
  query.addValue('league_id', leagueId);
  query.addValue('season_id', seasonId);
  query.addValue('locked', locked);

  return query.toString();
};
